<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
    <g>
      <path
        d="M11.159,33.806c-9.006-3.502-13.466-13.64-9.966-22.648C4.696,2.153,14.837-2.309,23.841,1.196
		c9.006,3.499,13.466,13.643,9.966,22.646C30.304,32.848,20.163,37.307,11.159,33.806"
      />
      <g id="svg_4">
        <ellipse
          id="svg_1"
          ry="3.30591"
          rx="3.22407"
          cy="17.47671"
          cx="22.36974"
          stroke="#ffffff"
          fill="#fff"
        />
        <ellipse
          id="svg_2"
          ry="3.30591"
          rx="3.22407"
          cy="8.0246"
          cx="22.32496"
          stroke="#ffffff"
          fill="#fff"
        />
        <ellipse
          id="svg_3"
          ry="3.30591"
          rx="3.22407"
          cy="26.9754"
          cx="22.36974"
          stroke="#ffffff"
          fill="#fff"
        />
      </g>
      <ellipse
        id="svg_5"
        ry="3.30591"
        rx="3.22407"
        cy="17.5"
        cx="11.1303"
        stroke="#ffffff"
        fill="#fff"
      />
      <line
        id="svg_6"
        y2="8.32719"
        x2="21.96673"
        y1="17.08087"
        x1="11.53331"
        stroke="#ffffff"
        fill="none"
      />
      <line
        id="svg_7"
        y2="26.43985"
        x2="22.01151"
        y1="18.05867"
        x1="11.21986"
        stroke="#ffffff"
        fill="none"
      />
      <line
        id="svg_8"
        y2="17.45344"
        x2="22.19062"
        y1="17.54656"
        x1="11.35419"
        stroke="#ffffff"
        fill="none"
      />
    </g>
  </svg>
</template>
